// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresSeasonStartBody = {
  poolId: string;
  doCarrySquares: boolean;
  eventId?: string | null;
  customDates?: {
    mode: "range" | "dates";
    fromDay?: string;
    toDay?: string;
    days?: string[];
  } | null;
  transactionId: string;
};

export type typeSquaresSeasonStartOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    status: "created" | "existing";
    squaresSeasonId: string;
    seasonNumber: number;
  };
};

export type typeSquaresSeasonStartOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSeasonStartOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSeasonStartOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresSeasonStartBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    doCarrySquares: { type: "boolean" },
    eventId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    customDates: {
      oneOf: [
        {
          type: "object",
          properties: {
            mode: { type: "string", enum: ["range", "dates"] },
            fromDay: { type: "string", maxLength: 3000, minLength: 1 },
            toDay: { type: "string", maxLength: 3000, minLength: 1 },
            days: {
              type: "array",
              items: { type: "string", maxLength: 3000, minLength: 1 },
            },
          },
          required: ["mode"],
        },
        { enum: [null] },
      ],
    },
    transactionId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "doCarrySquares", "transactionId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresSeasonStart(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresSeasonStartBody);
  }

  return async function postSquaresSeasonStart(
    payload: typeSquaresSeasonStartBody,
  ): Promise<
    typeSquaresSeasonStartOutput200 | typeSquaresSeasonStartOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresSeasonStart" failed before calling the network. #6742d1ad39f7`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#6742d1ad39f7" },
        },
        data: null,
      } as typeSquaresSeasonStartOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/season-start`,
      httpMethod: "POST",
      options,
    })) as typeSquaresSeasonStartOutput200 | typeSquaresSeasonStartOutput400;
  };
}
